import { getCoreDataSecuritySetupAuditTrailGraphSlice } from './get';

export const { requestGetCoreDataSecuritySetupAuditTrailGraph, resetGetCoreDataSecuritySetupAuditTrailGraph } =
    getCoreDataSecuritySetupAuditTrailGraphSlice.asyncActionCreators;
